import { render } from "./HorizontalDivider.vue?vue&type=template&id=b736be24"
import script from "./HorizontalDivider.vue?vue&type=script&lang=js"
export * from "./HorizontalDivider.vue?vue&type=script&lang=js"

import "./HorizontalDivider.vue?vue&type=style&index=0&id=b736be24&lang=css"
script.render = render

export default script